import SubstanceTrackerRepository from '@/repositories/SubstanceTrackerRepository';

import useAPI from './useAPI';

export const useSubstanceTrackerSummary = (personId: string) => {
  const repository = SubstanceTrackerRepository();

  return useAPI({
    queryKey: ['tracker_summary', personId],
    queryFn: async () => {
      return await repository.getSummary(personId);
    }
  });
};
